import { memo, useEffect } from 'react'

import { AnimatePresence } from 'framer-motion'

import CreditsLimit from './CreditsLimit'
import GenerateButton from './GenerateButton'
import SuccessTtsGeneration from './SuccessStateButton'
import * as Styled from './styled'
import { ttsThunks } from 'store/features/tts/thunks'
import { ttsSelectors } from 'store/features/tts/selectors'
import { useSelector } from 'react-redux'
import { dispatch } from 'store'
import { useGetTtsGenerateActionPerLimit } from './hooks'
import { TTS_GENERATION_STATUS } from 'consts/tts'

const TtsFooter: React.FC = () => {
  const isTtsItemsLoading = useSelector(ttsSelectors.isTtsItemsLoading)
  const isTtsGenerationFailed = useSelector(ttsSelectors.isTtsGenerationFailed)
  const ttsGenerationStatus = useSelector(ttsSelectors.ttsGenerationStatus)

  const isSuccessStateVisible =
    ttsGenerationStatus === TTS_GENERATION_STATUS.ok &&
    !isTtsItemsLoading &&
    !isTtsGenerationFailed

  const onGenerateTtsItems = () => {
    dispatch(ttsThunks.generateTtsItems())
  }

  const onClickAction = useGetTtsGenerateActionPerLimit(onGenerateTtsItems)

  useEffect(() => {
    // we need a little fake animation for the success state
    if (isSuccessStateVisible) {
      setTimeout(() => {
        dispatch(ttsThunks.setTtsGenerationStatus(null))
      }, 2000)
    }
  }, [isSuccessStateVisible])

  return (
    <AnimatePresence>
      <Styled.TtsFooterWrapper>
        {isSuccessStateVisible ? (
          <SuccessTtsGeneration />
        ) : (
          <GenerateButton
            onClick={onClickAction}
            isTtsGenerationLoading={isTtsItemsLoading}
          />
        )}
        <CreditsLimit isTtsGenerationLoading={isTtsItemsLoading} />
      </Styled.TtsFooterWrapper>
    </AnimatePresence>
  )
}

export default memo(TtsFooter)
